<template>
  <div class="flex flex-wrap justify-center gap-[.5rem]">
    <feather-icon
      :icon="icon"
      size="20"
      :class="`text-${variant}`"
    />
    <h5
      v-if="title"
      class="mb-0 font-weight-bolder"
      :class="`text-${variant}`"
      v-text="title"
    />
    <span
      v-if="!$slots.body"
      class="text-[#737373]"
    >{{ currentTime }}</span>
    <div
      class="cursor-pointer toastification-close-icon ml-auto inline-block flex justify-center"
      @click="$emit('close-toast')"
    >
      <feather-icon
        v-if="!hideClose"
        icon="XIcon"
        class="text-body"
      />
    </div>
    <div class="basis-full">
      <slot name="body" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.toastification-close-icon,
.toastification-title {
  line-height: 26px;
}

.toastification-title {
  color: inherit;
}
</style>

<script>
import moment from 'moment'

export default {
  props: {
    variant: {
      type: String,
      default: 'primary',
    },
    icon: {
      type: String,
      default: null,
      required: false,
    },
    title: {
      type: String,
      default: null,
    },
    text: {
      type: String,
      default: null,
    },
    hideClose: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      currentTime: '',
    }
  },
  mounted() {
    this.currentTime = this.moment().clone().locale('en').format('hh.mm.ss A')
  },
  methods: {
    moment,
  },
}
</script>
